import { twMerge } from 'tailwind-merge';

export const IconTiktok = ({ className, color = "#000000", size = '24' }) => {
  return (
    <svg className={twMerge('dark:[&_path]:fill-[#A9C7FF] dark:[&:hover_path]:fill-[#FCBC00] [&:hover_path]:fill-[#FCBC00]', className)} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2222 2H8.27778V10.2857C8.27778 11.1429 7.44444 12 6.61111 12C5.77778 12 4.94444 11.7143 4.94444 10.2857C4.94444 9.14286 5.99944 8.37771 6.88889 8.57143V6.57143C3.48889 6.57143 3 9.42857 3 10.2857C3 11.1429 3.54278 14 6.61111 14C9.12333 14 10.2222 12 10.2222 10.5714V6C10.8589 6.58171 11.8456 6.77543 13 6.85714V4.85714C11.3239 4.85714 10.2222 3.34057 10.2222 2Z" fill={color} />
    </svg>

  );
}